import {
  Backlinks,
  Dashboard,
  DomainBatchesList,
  GroupDomainList,
  GroupLinkbuilderBatchList,
  GroupListHasBatch,
  TaskList,
  UpdateUserDomainLinks,
  Users,
  Batches,
  Batch,
  TaskDetail,
  LinkBuilders,
  BacklinksType,
  BacklinkReadyStatus,
  BacklinksContent,
  AssignBacklinks,
  LinkBuildersReports,
  Merchants,
  NewBatches,
} from "../pages";
import Roles from "../pages/Roles";
import Templates from "../pages/Templates";
import Permissions from "../pages/Permissions";
import Mailbox from "../pages/Mailbox";
import InboxDetail from "../pages/Mailbox/InboxDetail";
import AssignDomainsToUser from "../pages/Users/AssignDomainsToUser";
import DomainsReport from "../pages/NewDomainsRpt";
import MoneyDomainReports from "../pages/Dashboard/MoneyDomainReport";
import BacklinkDetails from "../pages/Backlinks/BacklinkDetails";
import ReviewTask from "../pages/LinkBuilders/ReviewTask";
import ReviewTaskDetail from "../pages/LinkBuilders/ReviewTask/TaskDetail";
import HoldReason from "../pages/HoldReason";
import MoneyDomainReportPage from "../pages/Reports/MoneyDomainReport";
import LinkbuilderPerformanceReport from "../pages/Reports/PerformanceReport";
import NicheProducts from "../pages/NicheProducts";
import NicheSubCategory from "../pages/NicheSubCategory";
import TaskReports from "../pages/Reports/TaskReports";
import LeadPerformanceReports from "../pages/Reports/LeadPerformanceReports";
import SeoBacklinks from "../pages/SeoBacklinks";
import UserSessionLogs from "../pages/Reports/UserSessionLogs";
import GenerateContent from "../pages/GenerateContent";
import DomainOutreachReport from "../pages/Reports/DomainOutReachReport";
import GenerateBlog from "../pages/NewDomainsRpt/GenerateBlog";
import GenerateFaq from "../pages/NewDomainsRpt/GenerateFaq's";
import MessagesReport from "../pages/Reports/MessagesReport";
import GenerateContentPage from "../pages/NewDomainsRpt/GenerateContent";
import DomainBlogReport from "../pages/Reports/DomainBlogReport";
import DomainContentReport from "../pages/Reports/DomainContentReport";
import DomainBlogs from "../pages/Reports/DomainBlogs";
export const routes = [
  {
    path: "/dashboard",
    element: Dashboard,
    permission: "",
    pageTitle: "Dashboard",
  },
  {
    path: "/settings/users",
    element: Users,
    permission: "Users",
    pageTitle: "Users",
  },
  {
    path: "/users/:user",
    element: GroupListHasBatch,
    permission: "",
    pageTitle: "",
  },
  {
    path: "/users/:user/:group",
    element: GroupLinkbuilderBatchList,
    permission: "",
    pageTitle: "",
  },
  {
    path: "/users/:user/:group/:batch",
    element: GroupDomainList,
    permission: "",
    pageTitle: "",
  },
  {
    path: "/users/:user/:group/:batch/:domain",
    element: UpdateUserDomainLinks,
    permission: "Domains",
    pageTitle: "",
  },
  {
    path: "/settings/link-builders",
    element: LinkBuilders,
    permission: "Link Builders Report",
    pageTitle: "LinkBuilders",
  },
  {
    path: "/settings/link-builders/:linkBuilderId",
    element: TaskList,
    permission: "Link Builders Report",
    pageTitle: "TaskList",
  },
  {
    path: "/settings/link-builders/:linkBuilderId/:task",
    element: TaskDetail,
    permission: "Link Builders Report",
    pageTitle: "TaskDetail",
  },
  {
    path: "/reports/link-builders",
    element: LinkBuildersReports,
    permission: "",
    pageTitle: "LinkBuilders Reports",
  },
  {
    path: "/settings/roles",
    element: Roles,
    permission: "Roles",
    pageTitle: "Roles",
  },
  {
    path: "/settings/permissions",
    element: Permissions,
    permission: "Permissions",
    pageTitle: "Permissions",
  },
  {
    path: "/backlinks/backlinks-list",
    element: Backlinks,
    permission: "Backlinks",
    pageTitle: "Backlinks",
  },
  {
    path: "/backlinks/backlinks-type",
    element: BacklinksType,
    permission: "Backlink Type",
    pageTitle: "Backlinks Types",
  },
  {
    path: "/backlinks/content",
    element: BacklinksContent,
    permission: "Backlink Content",
    pageTitle: "Backlinks Content",
  },
  {
    path: "/backlinks/backlink-ready-status",
    element: BacklinkReadyStatus,
    permission: "Backlink Ready Status",
    pageTitle: "Backlink Ready Status",
  },
  {
    path: "/domains",
    element: DomainsReport,
    permission: "Domains",
    pageTitle: "Domains",
  },
  {
    path: "/domains/domain-batches-list",
    element: DomainBatchesList,
    permission: "Domains",
    pageTitle: "Domain Batches List",
  },
  {
    path: "/domains/assign-backlinks",
    element: AssignBacklinks,
    permission: "Backlinks",
    pageTitle: "Assign Backlinks",
  },

  {
    path: "/mailbox",
    element: Mailbox,
    permission: "Mailbox",
    pageTitle: "Mailbox",
  },
  {
    path: "/mailbox/detail",
    element: InboxDetail,
    permission: "Mailbox",
    pageTitle: "",
  },
  {
    path: "/batches",
    element: Batches,
    permission: "Batches",
    pageTitle: "Batches",
  },
  {
    path: "/batches/:batchId",
    element: Batch,
    permission: "Batches",
    pageTitle: "Batches",
  },
  {
    path: "/settings/templates",
    element: Templates,
    permission: "",
    pageTitle: "Templates",
  },
  {
    path: "/task-list",
    element: TaskList,
    permission: "Task List",
    pageTitle: "Task List",
  },
  {
    path: "/task-list/:task",
    element: TaskDetail,
    permission: "Task Detail",
    pageTitle: "Task Detail",
  },
  {
    path: "/assign_domains_to_user",
    element: AssignDomainsToUser,
    permission: "Assign Domains",
    pageTitle: "Assign Domains To User",
  },
  {
    path: "/settings/merchants",
    element: Merchants,
    permission: "Merchants",
    pageTitle: "Merchants",
  },
  {
    path: "/new_batches",
    element: NewBatches,
    permission: "Batches",
    pageTitle: "Batches",
  },
  {
    path: "/reports/money_domain_reports",
    element: MoneyDomainReports,
    permission: "Money Domain Reports",
    pageTitle: "Money Domain Reports",
  },
  {
    path: "/backlink_detail",
    element: BacklinkDetails,
    permission: "Backlinks",
    pageTitle: "Backlinks Detail",
  },
  {
    path: "/reports/review-task",
    element: ReviewTask,
    permission: "Review Tasks",
    pageTitle: "Review Tasks",
  },
  {
    path: "/reports/review-task/:task",
    element: ReviewTaskDetail,
    permission: "Review Tasks",
    pageTitle: "Review Task Detail",
  },
  {
    path: "/settings/hold-reason",
    element: HoldReason,
    permission: "Hold Reason",
    pageTitle: "Hold Reason",
  },
  {
    path: "/reports/money-domain-report",
    element: MoneyDomainReportPage,
    permission: "Money Domain Report",
    pageTitle: "Money Domain Report",
  },
  {
    path: "/reports/performance-report",
    element: LinkbuilderPerformanceReport,
    permission: "Linkbuilders Performance Report",
    pageTitle: "Linkbuilders Performance Report",
  },
  {
    path: "/settings/niche-category",
    element: NicheProducts,
    permission: "Niche Category",
    pageTitle: "Niche Category",
  },
  {
    path: "/settings/niche-sub-category",
    element: NicheSubCategory,
    permission: "Niche Sub Category",
    pageTitle: "Niche Sub Category",
  },
  {
    path: "/reports/task-report",
    element: TaskReports,
    permission: "Task Report",
    pageTitle: "Task Report",
  },
  {
    path: "/backlinks/seo-backlinks-list",
    element: SeoBacklinks,
    permission: "SEO Backlinks",
    pageTitle: "SEO Backlinks",
  },
  {
    path: "/reports/leads-performance-report",
    element: LeadPerformanceReports,
    permission: "Leader Performance Report",
    pageTitle: "Lead Performance Report",
  },
  {
    path: "/reports/users-activity-report",
    element: UserSessionLogs,
    permission: "Users Activity Report",
    pageTitle: "Users Activity Report",
  },
  {
    path: "/generate-content",
    element: GenerateContent,
    permission: "Generate Content",
    pageTitle: "Generate Content",
  },
  {
    path: "/reports/domain-outreach-report",
    element: DomainOutreachReport,
    permission: "Domain Outreach Report",
    pageTitle: "Domain Outreach Report",
  },
  {
    path: "/generateblog",
    element: GenerateBlog,
    permission: "",
    pageTitle: "Generate Blog",
  },
  {
    path: "/generatefaq",
    element: GenerateFaq,
    permission: "",
    pageTitle: "Generate Faq's",
  },
  {
    path: "/reports/messages-report",
    element: MessagesReport,
    permission: "Messages report",
    pageTitle: "Messages report",
  },
  {
    path: "/generatecontent",
    element: GenerateContentPage,
    permission: "",
    pageTitle: "Generate Content",
  },
  {
    path: "/reports/domain-blog-report",
    element: DomainBlogReport,
    permission: "",
    pageTitle: "Domain Blog Report",
  },
  {
    path: "/reports/domain-content-report",
    element: DomainContentReport,
    permission: "",
    pageTitle: "Domain Content Report",
  },
  {
    path: "/domain_blogs",
    element: DomainBlogs,
    permission: "Domain Blogs",
    pageTitle: "Domain Blogs",
  },
];
